var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"successBody"},[_c('div',{staticClass:"successDiv"},[_c('div',{staticClass:"success-content"},[_c('el-icon',{staticClass:"icon",attrs:{"name":"success"}}),_c('h1',[_vm._v("操作成功")]),_c('p',[_vm._v("您将在 "+_vm._s(_vm.countdown)+" 秒后被重定向到登录页面。")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }